/// <amd-module name="VSSUI/Components/Panel/PanelOverlay" />
import * as React from "react";

import { IPanelOverlayProps } from "VSSUI/Components/Panel/Panel.Props";

export const PanelOverlay: React.SFC<IPanelOverlayProps> = props => {
    return (
        <>
            <div className="absolute-fill bolt-panel-overlay sub-layer" />
            <div className="absolute-fill flex-column flex-center justify-center sub-layer">{props.overlayContent}</div>
        </>
    );
};
